import { ReactNode, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useUser } from '@/hooks/use-user';

interface InternalGuardProps {
  children: ReactNode;
}

export function InternalGuard({ children }: InternalGuardProps) {
  const user = useUser();
  const navigate = useNavigate();
  const { dealId } = useParams<{ dealId: string }>();
  const { search, hash } = useLocation();

  useEffect(() => {
    if (user && !user.isInternalUser) {
      if (dealId) {
        navigate(`/deal/${dealId}${search}${hash}`, { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    }
  }, [user, dealId, search, hash, navigate]);

  if (user && !user.isInternalUser) {
    return null;
  }

  return <>{children}</>;
}
